import { AlertTriangle, Inbox, LoaderCircle } from "lucide-react";
import { formatApiError } from "../api/client";

export function LoadingState({ label = "جارٍ تحميل البيانات" }: { label?: string }) {
  return (
    <div className="state-card" role="status" aria-live="polite">
      <LoaderCircle className="spin" aria-hidden="true" />
      <span>{label}…</span>
    </div>
  );
}

export function ErrorState({ error, retry }: { error: unknown; retry?: () => void }) {
  return (
    <div className="state-card state-card--error" role="alert">
      <AlertTriangle aria-hidden="true" />
      <div>
        <strong>تعذر عرض البيانات</strong>
        <p>{formatApiError(error)}</p>
      </div>
      {retry ? (
        <button className="button button--secondary" type="button" onClick={retry}>
          إعادة المحاولة
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({ title, description }: { title: string; description: string }) {
  return (
    <div className="state-card">
      <Inbox aria-hidden="true" />
      <div>
        <strong>{title}</strong>
        <p>{description}</p>
      </div>
    </div>
  );
}

export function StatusBadge({ status }: { status: string }) {
  const label: Record<string, string> = {
    active: "نشط",
    ready: "جاهزة",
    in_progress: "قيد التوزيع",
    draft: "مسودة",
    completed: "مكتملة",
    delivered: "تم التسليم",
    allocated: "مخصّصة",
    no_show: "لم يحضر",
    suspended: "موقوف",
    locked: "مقفلة",
    sent: "مرسل",
    read: "مقروء"
  };
  return <span className={`status status--${status}`}>{label[status] ?? status}</span>;
}
